import { InboxIcon, type LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

interface EmptyStateProps {
  /** Asosiy qator (qalin). Berilmasa `description` ishlatiladi. */
  title?: string;
  /** Ixtiyoriy, xiraroq ikkinchi qator. */
  description?: string;
  /** Ikonka komponenti (standarti — "inbox"). */
  icon?: LucideIcon;
  /** Matn ostida chiqadigan ixtiyoriy amal tugmasi. */
  action?: React.ReactNode;
  className?: string;
}

/**
 * Bo'sh holat uchun ko'rinish: yumshoq gradientli ikonka nishoni, sarlavha va
 * ixtiyoriy tavsif + amal. Ro'yxat yoki to'rda element bo'lmaganda ishlatiladi.
 */
export const EmptyState = ({
  title,
  description,
  icon: Icon = InboxIcon,
  action,
  className,
}: EmptyStateProps) => {
  return (
    <div
      className={cn(
        "border-border bg-muted/20 flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed px-6 py-16 text-center",
        className,
      )}
    >
      <span className="from-primary/15 to-primary/5 text-primary ring-primary/10 flex size-16 items-center justify-center rounded-2xl bg-gradient-to-br ring-1">
        <Icon className="size-8" />
      </span>
      {title && <p className="text-foreground text-base font-semibold">{title}</p>}
      {description && <p className="text-muted-foreground max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
};

/**
 * Faqat `description` uzatadigan eski chaqiruv joylari uchun qoldirilgan yupqa
 * o'ram. Yangi kodda {@link EmptyState} ishlatiladi.
 */
export const Empty = ({ description }: { description: string }) => (
  <EmptyState title={description} className="my-5 border-none bg-transparent py-8" />
);
